import { render, staticRenderFns } from "./Teacher.vue?vue&type=template&id=b171c27e"
import script from "./Teacher.vue?vue&type=script&lang=js"
export * from "./Teacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b171c27e')) {
      api.createRecord('b171c27e', component.options)
    } else {
      api.reload('b171c27e', component.options)
    }
    module.hot.accept("./Teacher.vue?vue&type=template&id=b171c27e", function () {
      api.rerender('b171c27e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/Teacher.vue"
export default component.exports